import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialMicrosoftTeamsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialMicrosoftTeams",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.34 8.46c0-1.62-1.32-2.94-2.94-2.94s-2.94 1.32-2.94 2.94 1.32 2.94 2.94 2.94 2.94-1.32 2.94-2.94M16.15 21.47V10.25c0-.81-.66-1.47-1.48-1.47H3.47c-.81 0-1.47.66-1.47 1.47v11.22c0 .81.66 1.47 1.47 1.47h11.21c.81 0 1.47-.65 1.48-1.45v-.01Zm-3.93-8.12h-2.4v6.52H8.29v-6.52H5.9v-1.27h6.31v1.27Zm16.52-.64H25.4v7.49c0 3.02.06 3.83-.67 4.76-.11.14-.09.37.17.37.42-.02.83-.09 1.22-.24 1.13-.27 3.87-2.01 3.87-4.55v-6.6c0-.69-.56-1.24-1.24-1.24h-.01ZM17.24 2.9c-2.36 0-4.28 1.92-4.28 4.28-.01.16-.01.31 0 .47h2.58c.94 0 1.7.77 1.7 1.71v2.03a4.277 4.277 0 0 0 0-8.49m5.67 9.81h-5.6v9.63c0 .94-.76 1.71-1.7 1.71h-5.45a7.37 7.37 0 0 0 6.76 5.06 7.38 7.38 0 0 0 7.2-7.49v-7.66c.01-.68-.52-1.23-1.2-1.25Z"
    })
  }));
};